class TableActionsSelectListener extends AbstractInputListener
{

    listen()
    {
        let context = this;
        $(document).on('change', context.selector, function (){

            let val = $(this).val();




            let email_dependant_actions = ['send_pdfs_to_email', 'send_pdf_to_email'];

            //PRIKAZI POLJE ZA EMAIL, i da je obavezno
            if(email_dependant_actions.includes(val))
            {

                $(context.operations_interface.selectors.getActionsEmailHolderSelector()).removeClass('hide');
                $(context.operations_interface.selectors.getActionsEmailSelector()).addClass('pulse').prop('required', true);


            }
            else
            {
                $(context.operations_interface.selectors.getActionsEmailHolderSelector()).addClass('hide');
                $(context.operations_interface.selectors.getActionsEmailSelector()).removeAttr('required');
            }

        });



    }

}